import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DeviceList from "./pages/DeviceList";
import DeviceRead from "./pages/DeviceRead";
import DeviceCreate from "./pages/DeviceCreate";
import DeviceUpdate from "./pages/DeviceUpdate";
import ServiceList from "./pages/ServiceList";
import ServiceRead from "./pages/ServiceRead";
import ServiceCreate from "./pages/ServiceCreate";
import ServiceUpdate from "./pages/ServiceUpdate";
import AppList from "./pages/AppList";
import AppRead from "./pages/AppRead";
import AppCreate from "./pages/AppCreate";
import AppUpdate from "./pages/AppUpdate";
import FileList from "./pages/FileList";
import FileRead from "./pages/FileRead";
import FileCreate from "./pages/FileCreate";
import FileUpdate from "./pages/FileUpdate";
import LogDump from "./pages/LogDump";

export default function Top() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/devices" element={<DeviceList/>} />
        <Route path="/devices/create" element={<DeviceCreate/>} />
        <Route path="/devices/:id" element={<DeviceRead/>} />
        <Route path="/devices/update/:id" element={<DeviceUpdate/>} />
        <Route path="/services" element={<ServiceList/>} />
        <Route path="/services/create" element={<ServiceCreate/>} />
        <Route path="/services/update/:id" element={<ServiceUpdate/>} />
        <Route path="/services/:id" element={<ServiceRead/>} />
        <Route path="/apps" element={<AppList/>} />
        <Route path="/apps/create" element={<AppCreate/>} />
        <Route path="/apps/update/:id" element={<AppUpdate/>} />
        <Route path="/apps/:id" element={<AppRead/>} />
        <Route path="/files" element={<FileList/>} />
        <Route path="/files/create" element={<FileCreate/>} />
        <Route path="/files/update/:id" element={<FileUpdate/>} />
        <Route path="/files/:id" element={<FileRead/>} />
        <Route path="/logs" element={<LogDump/>} />
        <Route path="/" element={<DeviceList/>} />
      </Routes>
    </BrowserRouter>
  );
}
